module.exports = __webpack_public_path__ + "static/our-story-2b55a834f53d397d9c0a07e2e5d83c91.png";